import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '@auth0/auth0-angular';
import { catchError, throwError, switchMap, take } from 'rxjs';
import { inject } from '@angular/core';

import { BaseAuthService } from '../services/common/base-auth.service';
import { CookiesService } from '../services/common/cookies.service';
import { environment } from '../../../environments/environment';
import { PermissionService } from '../services/common/permission.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookiesService);
  const baseAuth = inject(BaseAuthService);
  const auth0 = inject(AuthService);
  const permissionService = inject(PermissionService);

  if (req.url.includes('pharma-manager')) {
    // Ler o token diretamente do Auth0
    return auth0.idTokenClaims$.pipe(
      take(1),
      switchMap((tokenClaims) => {
        const authToken = tokenClaims?.__raw;

        if (authToken) {
          const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${authToken}`),
          });
          return next(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status === 401) {
                if (permissionService.isAdminRole()) {
                  return throwError(() => error);
                } else {
                  auth0.logout();
                }
              }

              return throwError(() => error);
            })
          );
        } else {
          // Se não há token, continuar sem autenticação
          return next(req);
        }
      })
    );
  } else if (req.url.includes('lexos-api')) {
    const authReq = req.clone({
      headers: req.headers.set(
        'Authorization',
        `Bearer ${environment.TOKEN_LEXOS_API}`
      ),
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  } else if (req.url.includes(environment.inovaServerCheckUrl) || req.url.includes(environment.inovaActivationUrl)) {
    const authReq = req.clone({
      headers: req.headers.set(
        'Authorization',
        `Bearer ${environment.inovaToken}`
      ),
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  return next(req);
};
